import React from 'react'
import UnitCountTwo from '../components/child/UnitCountTwo'
import RevenueGrowthOne from '../components/child/RevenueGrowthOne'
import EarningStaticOne from '../components/child/EarningStaticOne'
import OverviewStaticOne from '../components/child/OverviewStaticOne'
import ClientPaymentOne from '../components/child/ClientPaymentOne'
import CountryStatusOne from '../components/child/CountryStatusOne'
import TopPerformanceOne from '../components/child/TopperformanceOne'
import LatestPerformanceOne from '../components/child/LatestPerformanceOne'
import LastTransactionOne from '../components/child/LastTransactionOne'


const AdminDashboardLayer = () => {
  return (
    <section className="row gy-4">
      {/* UnitCountTwo */}
      <UnitCountTwo />

      {/* OverviewStaticOne */}
      <OverviewStaticOne />

      {/* RevenueGrowthOne */}
      {/* <RevenueGrowthOne /> */}

      {/* EarningStaticOne */}
      {/* <EarningStaticOne /> */}


      {/* ClientPaymentOne  */}
      {/* <ClientPaymentOne /> */}

      {/* CountryStatusOne */}
      {/* <CountryStatusOne /> */}

      {/* TopPerformanceOne */}
      <TopPerformanceOne />

      {/* LatestPerformanceOne */}
      {/* <LatestPerformanceOne /> */}
      
      {/* LastTransactionOne */}
      {/* <LastTransactionOne /> */}
    </section>
  )
}

export default AdminDashboardLayer
